import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

type NotificationNotesDialogProps = {
    open: boolean;
    initialComment: string;
    onClose: () => void;
    onSave: (comment: string) => void;
};

const NotificationNotesDialog: FC<NotificationNotesDialogProps> = ({
    open,
    initialComment,
    onClose,
    onSave,
}: NotificationNotesDialogProps) => {
    const { t: translate } = useTranslation(['common', 'notifications']);
    const [comment, setComment] = useState(initialComment);

    useEffect(() => {
        if (open) {
            setComment(initialComment);
        }
    }, [open, initialComment]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{translate('notifications:EDIT_NOTES')}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={3}
                    margin="dense"
                    label={translate('notifications:NOTES')}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('common:CANCEL')}</Button>
                <Button variant="contained" onClick={() => onSave(comment)}>
                    {translate('common:SAVE')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NotificationNotesDialog;
